function save(session, periodObj) {
    const {Period} = session;
    return Period.create(periodObj);
}

function remove(session, id) {
    const {Period} = session;
    if (!Period.idExists(id)) {
        throw new Error(`can not find period with id '${id}'`);
    }
    return Period.withId(id).delete();
}


export default {
    save,
    remove,
};